import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  AfterViewInit,
  ChangeDetectorRef 
} from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
import { constantUrl } from "../../Shared/constantUrl";
import { MatSnackBarConfig, MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LosService } from "../../_LOS/services/los.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
declare var $: any;
import { QuickLoanService } from "../services/quickLoan.service";
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Component({
    selector: "app-quickloan-loan-info",
    templateUrl: "./quickloan-loan-info.component.html",
    styleUrls: ["./quickloan-loan-info.component.scss"],
    standalone: false
})
export class QuickloanLoanInfoComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  loading: boolean = false;
  BranchesList: any[] = [];
  CustomerId: number = 0;
  branchHeadData: any = [];
  ProductList: any[] = [];
  loanInfoModel: any = {};
  @Input() Revert_IsEdit: any;
  TypeFrom: any = "LMS";
  isSaveLoanEnabled: boolean = false;
  leadSourceDropdown: any = [];
  partnerDropdown: any = [];
  SalesExecutiveData: any = [];
  areaData: any = [];
  CollectionExecutiveData: any = [];
  SourceAreaData: any = [];
  subAreaData: any = [];
  InfoData: any;
  openmodel: any="QuickLoanInfo";
  digioresponse: any="QuickLoanInfoDIGIO";
  sdkEventData: any;
  digiosdkEventData: any;
  customerPhoneNo: string = ''; 
  OTPCode: any;
  OTP: string = '';
  otp1: string = '';
  otp2: string = '';
  otp3: string = '';
  otp4: string = '';
  otp5: string = '';
  otp6: string = '';
  otpValidationState: 'idle' | 'success' | 'error' = 'idle';
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() isNew: boolean;
  @Input() Status: any;
  @Input() ProcessName: any;
  @Input() InquiryId: any;
  IsSave: boolean = false;
  IsUpdate: boolean = false;
  IsEdit: boolean = false;
  IsDisabled: boolean = false;
  displayedDetailColumns: string[];
  showAddCustomerButton: boolean = true;
  showCustomerTable: boolean = false;
  dataCustomerSource: any[] = [];
  previousCustomerSource: any[] = [];
  customerData: any = {};
  CustomerAddress: any;
  loanSegementView: any;
 customerProfileBaseUrl: any = constantUrl.customerProfilePicUrl;
  CustomerPicDetail: any;


  displayedCustomerColumns: string[] = ['Number','CustomerId','CustomerName','GenderAge','PhoneNo','RelationName'];

  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  @Input() ProductId: any;
  dataSourceDetail: any = new MatTableDataSource([]);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (this.sort != undefined) {
      this.dataSourceDetail.sort = this.sort;
    }
  }
  constructor(
    private _Route: Router,
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private _EncrDecrService: EncrDecrService,
    private _QuickLoanService: QuickLoanService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next(this.ProcessName);
    if(this.loanSummary == null){
      this.loanSummary={LoanId:0,ApplicationIdentity:0}
    }

    // console.log("this.Status", this.Status);
    if (!this.isNew) {
      this.IsEdit = true;
      this.IsSave = false;
      this.IsDisabled = true;

      setTimeout(() => {
        this.get_Save_LoanInfo();
      }, 300);
    } else {
      this.loanInfoModel.Branch_Id = "";
      this.loanInfoModel.LoanProduct_Id = "";
      this.loanInfoModel.SelectBranchHead = "";
      this.loanInfoModel.SelectSourceType = "";
      this.loanInfoModel.LeadSourceName = "";

      this.loanInfoModel.SelectSourceArea = "";
      this.loanInfoModel.SalesExecutive = "";
      this.loanInfoModel.CollectionExecutive = "";
      this.loanInfoModel.SelectArea = "";
      this.loanInfoModel.SelectSubarea = "";
      this.loanInfoModel.LoanPurpose = "";
      this.IsEdit = false;
      this.IsSave = true;
      this.IsDisabled = false;
      if (this.InquiryId) {
        this.losService
          .LOS_GetInquiryDetails({ InquiryId: this.InquiryId })
          .subscribe((res: any) => {
            if (res.length > 0) {
              this.loanInfoModel.LoanPurpose = res[0].Purpose;
              this.loanInfoModel.Branch_Id = res[0].BranchId;
              this.loanInfoModel.LoanProduct_Id = Number(res[0].Product_id);
              this.getAppNo_AND_LoanNo();
              this.loanInfoModel.SelectSourceType = res[0].Source_id;
               this.Get_PartnerForDropdown(false);
              this.loanInfoModel.LeadSourceName= res[0].Source_Name;  
              this.loanInfoModel.SalesExecutive= res[0].SalesExecutive;
            }
          });
      }
    }

    this.getBranchesList();
    this.getProductDropdown();
    this.getLeadSourceDropdown();

    if (this.loanSummary != undefined) this.getTATTableData();
  }

  

  getAppNo_AND_LoanNo() {
    this.LmsService.getAppNo_AND_LoanNo({
      Branch_Id: this.loanInfoModel.Branch_Id,
    }).subscribe((res: any) => {
      // console.log("res", res);
      if (res.length > 0) {
        this.loanInfoModel.ApplicationNo = res[0].ApplicationNo;
      }
      if (this.loanSummary != undefined) this.getTATTableData();
    });
    this.loanInfoModel.SelectBranchHead = "";
    this.getBranchHead(this.loanInfoModel.Branch_Id);
    this.getAreaByBranch(this.loanInfoModel.Branch_Id);
    this.GetCollectionExecutive(
      this.loanInfoModel.Branch_Id,
      this.loanInfoModel.LoanProduct_Id
    );
    this.GetSalesExecutive(
      this.loanInfoModel.Branch_Id,
      this.loanInfoModel.LoanProduct_Id
    );
  }

  getBranchHead(value) {
    this.LmsService.Get_Lms_BranchHead_ByBranch({ Branch_Id: value }).subscribe(
      (res: any) => {
        if (res.length > 0) {
          this.branchHeadData = res;
          this.loanInfoModel.SelectBranchHead = this.branchHeadData[0].EmpId;
        }
      }
    );
  }

  getBranchesList() {
    this.LmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe(
      (result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
        // console.log(this.BranchesList.length==1)
        if (this.BranchesList.length == 1) {
          this.loanInfoModel.Branch_Id = this.BranchesList["0"]?.BranchId;
          this.getAppNo_AND_LoanNo();
        }
      }
    );
  }
  getProductDropdown() {
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result: any) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
      });
  }

  getLeadSourceDropdown() {
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
    });
  }

  Get_PartnerForDropdown(isChange: boolean = true) {
    if (isChange) {
      this.loanInfoModel.LeadSourceName = "";
    }
    if (
      this.loanInfoModel.SelectSourceType == "Agent" ||
      this.loanInfoModel.SelectSourceType == "DSA" ||
      this.loanInfoModel.SelectSourceType == "Dealer"
    ) {
      this.losService
        .Get_PartnerForDropdown({
          PartnerType: this.loanInfoModel.SelectSourceType,
          branchId: this.loanInfoModel.Branch_Id,
        })
        .subscribe((res: any) => {
          this.partnerDropdown = res;
        });
    }

    if (
      this.loanInfoModel.SelectSourceType == "Sales Executive" ||
      this.loanInfoModel.SelectSourceType == "Telecaller Executive" ||
      this.loanInfoModel.SelectSourceType == "Marketing Executive"
    ) {
      this.losService
        .getEmployeeDropdown({
          BranchId: this.loanInfoModel.Branch_Id,
          ProcessId: 1,
          ProductId: this.loanInfoModel.LoanProduct_Id,
        })

        .subscribe((res: any) => {
          this.SalesExecutiveData = res;

          this.partnerDropdown = [];
          this.SalesExecutiveData.forEach((obj: any) => {
            this.partnerDropdown.push({
              PartnerId: obj.EmpId,
              Partner_Name: obj.EmpName,
            });
          });
        });
      // console.log("Partnerrrrrrrrrr", this.partnerDropdown);
    }
  }
  getAreaByBranch(value) {
    this.LmsService.Get_Lms_Area_ByBranch({ Branch_Id: value }).subscribe(
      (res: any) => {
        this.areaData = res;
      }
    );
  }

  GetCollectionExecutive(value, productID) {
    this.LmsService.Get_Lms_CollectionExecutive({
      Branch_Id: value,
      ProductId: productID,
    }).subscribe((response) => {
      this.CollectionExecutiveData = response;
    });
  }
  GetSalesExecutive(value, productID) {
    this.losService
      .getEmployeeDropdown({
        BranchId: value,
        ProcessId: 1,
        ProductId: productID,
      })
      .subscribe((res: any) => {
        this.SalesExecutiveData = res;
        //this.Get_PartnerForDropdown();
      });
  }

  changeArea(isChange: boolean = true) {
    if (isChange) {
      this.loanInfoModel.SelectSubarea = "";
    }
    this.LmsService.Get_Lms_SubArea_ByArea({
      Area_Id: Number(this.loanInfoModel.SelectArea),
    }).subscribe((res: any) => {
      this.subAreaData = res;
    });
  }
// Save button click pe
onSaveButtonClick() {
  this._MasterService.Get_Sms_Configration({
    Step_Name: "Application_Login"
    }).subscribe((res: any) => {
      if (res.length > 0 ){
    $("#OTPModel").modal("show");
    $("#OTPModel").css("z-index", "1050");
    this.CkeckApplicationLoginOtpMsg(this.customerPhoneNo);
 }
 else {
    this.SaveLoanInfo();
 }
    })

}

 CkeckApplicationLoginOtpMsg(MobileNo) {
   
              let payload = {
                Phone_No: MobileNo,
              };
              this._MasterService
                .SendEventBasedNotif({
                  LoanId: this.loanSummary.LoanId,
                  EventName: 'Application_Login',
                  JSON: payload,
                  IsCustomer:  1
                })
                .subscribe((response: any) => {
                
                    const smsSuccess = response?.SMS?.[0].Code == 1 
                  const mailSuccess = response?.Email?.Success === true
                
                  if (smsSuccess || mailSuccess){
                    
                    if (smsSuccess) {
                      this.OTPCode = response.SMS[0].Msg;
                    } else if (mailSuccess) {
                      this.OTPCode = response?.Email?.Msg; 
                     
                    }
                    return true;
                  }
         else {
        
          return false;
        }

      })
    return false;
  }

onOtpInput(event: any, nextInputId: string, prevInputId: string) {
    if (this.otpValidationState === 'success') return;
    
    const input = event.target;
    const value = input.value;
    const key = event.key;

    if (key === 'Backspace' && !value) {
      if (prevInputId) {
        document.getElementById(prevInputId)?.focus();
      }
    } else if (value.length === 1 && nextInputId) {
      document.getElementById(nextInputId)?.focus();
    }
    
    this.OTP = `${this.otp1}${this.otp2}${this.otp3}${this.otp4}${this.otp5}${this.otp6}`;
    this.otpValidationState = 'idle';
}

// OTP verify
onOTPModelOTP() {
    if (this.OTPCode != this.OTP) {
        this.otpValidationState = 'error';
        setTimeout(() => {
          this.otpValidationState = 'idle'; 
        }, 1000);
        this.snackBar.openFromComponent(SnackbarComponent, {
            data: "OTP is not valid",
            ...this.configSuccess,
        });
        return;
    }
    
    // OTP is valid
    this.otpValidationState = 'success';
    setTimeout(() => {
        this.OTPCode = '';
        this.OTP = '';
        this.otpValidationState = 'idle';
        this.onOTPModelClose();
        this.SaveLoanInfo(); 
    }, 1200); 
}

onOTPModelClose() {
    this.OTP = '';
    this.otp1 = '';
    this.otp2 = '';
    this.otp3 = '';
    this.otp4 = '';
    this.otp5 = '';
    this.otp6 = '';
    this.otpValidationState = 'idle';
    $("#OTPModel").modal("hide");
}

  SaveLoanInfo() {
  // if (!this.CustomerId || this.CustomerId <= 0) {
  //   this.snackBar.openFromComponent(SnackbarComponent, {
  //     data: "Please select a customer before saving the loan.",
  //     ...this.configSuccess
  //   });
  //   return;
  // }
  this.IsDisabled = true; // disable save button immediately

  const Loan_Id = this.loanSummary?.LoanId || 0;

  const payload = {
    BranchId: this.loanInfoModel.Branch_Id,
    PrductId: this.loanInfoModel.LoanProduct_Id,
    Process_Id: this.Processid,
    Page_Id: this.PageData.MM_Id,
    LoginUserId: this.currentUser.userId,
    LoanPurpose: this.loanInfoModel.LoanPurpose,
    Loan_Id: Loan_Id,
    CollectionExecutive: this.loanInfoModel.CollectionExecutive || 0,
    SelectSourceArea: this.loanInfoModel.SelectSourceArea || "0",
    SelectSubarea: this.loanInfoModel.SelectSubarea || 0,
    SalesExecutive: this.loanInfoModel.SalesExecutive,
    SelectArea: this.loanInfoModel.SelectArea || 0,
    LeadReference: this.loanInfoModel.LeadReference,
    LeadSourceName: this.loanInfoModel.LeadSourceName,
    SelectSourceType: this.loanInfoModel.SelectSourceType,
    SelectBranchHead: this.loanInfoModel.SelectBranchHead,
    inquiryId: this.InquiryId || 0,
    CustomerId: this.CustomerId // <-- new parameter for combined SP
  };

  this._QuickLoanService.QuickLoan_Save_Application(payload)
    .pipe(
      catchError(err => {
        console.error('Error saving loan:', err);
        this.IsDisabled = false; // re-enable if error
        return of(null);
      })
    )
    .subscribe((res: any) => {
      const response = res?.[0];
      if (!response) return;

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: response.MSG,
        ...this.configSuccess
      });

      if (res && res.length > 0 && response.CODE > 0) {
        this.QuickLoan_Save_PageProcess( "Loan Info",response.CODE , 1);
        this.QuickLoan_Save_PageProcess( "Customer Details",response.CODE , 2);
        const encryptedProcessId = this._EncrDecrService.encrypt(
          encodeURIComponent(this.Processid)
        );
        const encryptedProductId = this._EncrDecrService.encrypt(
          encodeURIComponent(this.loanInfoModel.LoanProduct_Id)
        );
        const encryptedLoanId = this._EncrDecrService.encrypt(
          encodeURIComponent(response.CODE)
        );
        const status = this.Status || "P";
        const revertedProcessId = this._EncrDecrService.encrypt(
          encodeURIComponent(0)
        );

        // Navigate only after loan + customer saved successfully
        this._Route.navigate([
          `quickloan-dashboard/quick-loan/details/${encryptedProcessId}/${encryptedProductId}/${encryptedLoanId}/${status}/${revertedProcessId}`
        ]);
        
        // this.QuickLoan_Save_PageProcess( "Loan Info", response.CODE);
        this.get_Save_LoanInfo();
        this.IsEdit = true;
        this.IsUpdate = false;
       
      } else {
        // handle failed save
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: response.MSG || "Failed to save loan.",
          ...this.configSuccess
        });
        this.IsDisabled = true; // re-enable save button
        
      }
    });
}


  get_Save_LoanInfo() {
    this.showAddCustomerButton = false;
    this.showCustomerTable = false;
    // console.log("this.loanSummary 1245", this.loanSummary);
    this.LmsService.get_Saved_LoanInfo({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((res: any) => {
      // console.log("get_Saved_LoanInfo", res);
      this.loanInfoModel = res[0];
      this.loanInfoModel.Branch_Id = this.loanSummary.BranchId;
      this.loanInfoModel.ApplicationNo = this.loanSummary.ApplicationNo;
      this.loanInfoModel.LoanProduct_Id = this.loanSummary.ProductId;

      this.loanInfoModel.SelectBranchHead = res[0].BranchHead;
      this.loanInfoModel.SelectSourceType = res[0].SourceType;
      this.loanInfoModel.SelectSourceArea = res[0].SourceArea;
      this.loanInfoModel.SelectArea = res[0].Area;
      this.loanInfoModel.SelectSubarea = res[0].Subarea;

      this.getAreaByBranch(this.loanSummary.BranchId);
      this.getBranchHead(this.loanSummary.BranchId);
      this.GetCollectionExecutive(
        this.loanSummary.BranchId,
        this.loanSummary.ProductId
      );
      this.GetSalesExecutive(
        this.loanSummary.BranchId,
        this.loanSummary.ProductId
      );
      this.Get_PartnerForDropdown(false);
      this.changeArea(false);

       this.Get_LMS_Customer_Loan_EmiDetails();
      
      
    });
  }

  onEditLoanInfo() {
    this.IsEdit = false;
    this.IsUpdate = true;
    this.IsDisabled = false;
  }

  CheckCustomerLoanInfo() {
    if (this.loanSummary) {
      this.QuickLoan_Save_PageProcess("Loan Info", this.loanSummary.LoanId,this.PageData.MM_Id);
      this.action.emit("next");
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please fill all details.",
        ...this.configSuccess,
      });
    }
  }

  QuickLoan_Save_PageProcess(PageType, LoanId,MM_Id) {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: PageType,
        ProductId: this.loanInfoModel.LoanProduct_Id,
        Loan_Id: LoanId,
        Process_Id: this.Processid,
        Page_Id: MM_Id,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => {
        //return res[0].CODE;
      });
  }

  //get TAT Table Data
  getTATTableData() {
    // console.log("loan Id"+this.loanSummary.LoanId)
    this._QuickLoanService
      .Quick_rpt_TAT_Report({ LoanId: this.loanSummary.LoanId })
      .subscribe((res) => {
        if (res["Item2"].length > 0) {
          this.displayedDetailColumns = [
            "ProcessId",
            "Process",
            "ProcessExecutive",
            "ProcessStatus",
            "AssignedOn",
            "CompletedOn",
            "TAT_Hr",
            "Maximum_Standard_Tat",
            "TAT_Status",
            "Remark",
            "LatLong",
          ];
          var TatReportsList = JSON.parse(JSON.stringify(res));
          this.dataSourceDetail = new MatTableDataSource(TatReportsList.Item2);
          this.dataSourceDetail.sort = this.sort;
        } else {
          this.dataSourceDetail = new MatTableDataSource([]);
          this.dataSourceDetail.sort = this.sort;
        }
      });
  }

  // onSelectMethods($event){
  //   console.log("Triggered")
  // }

  onChangeSalesExecutive(val: any) {
    if ((this.CollectionExecutiveData as []).find((x) => x["EmpId"] == val)) {
      this.loanInfoModel.CollectionExecutive = val;
    }
  }


  GetData(event: any) {
    if (event?.data && event.data[0]?.CODE) {
        const customerId = event.data[0].CODE;
        console.log("Customer Id:", customerId);

      this.CustomerId = customerId; // ✅ assign it here
      this.CustomerId = event.data[0].CODE;
        console.log("Customer Id:", this.CustomerId);

     this.LmsService.Get_LMS_CustomerDetails({ CustomerId: String(this.CustomerId) })
      .subscribe((res: any) => {
        console.log("Fetched Customer Details:", res);

        if (res && res.Item1 && res.Item1.length > 0) {
          // Customer exists → hide Add Customer button, show table, enable Save Loan
          this.showAddCustomerButton = false;
          this.showCustomerTable = true;
          this.dataCustomerSource = res.Item1;
           this.previousCustomerSource = [...res.Item1];
          this.isSaveLoanEnabled = true;
          this.customerPhoneNo = res.Item1[0]?.PhoneNo || '';
        } else {
          // No customer → show Add button, disable Save Loan
          this.showAddCustomerButton = true;
          this.showCustomerTable =false;
          this.isSaveLoanEnabled = false;
          this.dataCustomerSource = [];
        }
      });
  } else {
    // No customer selected
    this.showAddCustomerButton = true;
    this.isSaveLoanEnabled = true;
    this.dataCustomerSource = [];
  }

  this.LMS_GetLoanDetails();
}
  LMS_GetLoanDetails(loan_id: number = 0) {
 
  this.LmsService.LMS_GetLoanDetails({Loan_Id: loan_id}).subscribe((res: any) => {
    // handle response
  });
  }

  Get_LMS_Customer_Loan_EmiDetails() {
    this.LmsService.LMS_GetLoanDetails({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((res: any) => {
      // console.log("Result of Get loan details :", res);
      this.showSpinner = false;
      this.CustomerAddress = res.Item3[0];

      // console.log("Customer Address", this.CustomerAddress);

      this.customerData = res.Item2[0];
      this.loanSegementView = res.Item1[0].LoanSegment;
      // console.log(
      //   "Phone no verfication console lg",
      //   this.customerData.PhoneNoIsVerified
      // );
      if (this.customerData.ProfilePic) {
        this.CustomerPicDetail =
          this.customerProfileBaseUrl +
          this.customerData.CustomerId +
          "/" +
          this.customerData.ProfilePic;
      } else {
        this.CustomerPicDetail = "../assets/images/profile.png";
      }
      // console.log("Customer Name :", this.customerData.Customer);

      // this.EMIDetails = res.Item7[0];
      // console.log("Mature EMI_Amount", this.EMIDetails);
    });

    // this.CustomerViewDetailRequestModel.CustomerId =
    //   this.loanSummary.CustomerId.toString();
    // this.LmsService.Get_LMS_CustomerDetails(
    //   this.CustomerViewDetailRequestModel
    // ).subscribe((result: any) => {
    //   if (result != null) {
    //     console.log("all Result", result);
    //     this.customerData = result.Item1[0];
    //     // console.log("Result of customer data", this.customerData);
    //     this.addressList = result.Item2;
    //     // console.log("Result of customer data add", this.addressList);
    //     this.CategoryList = result.Item3;
    //     // console.log("Result of customer data add", this.CategoryList);
    //   }
    // });
  }
  viewCustomerDetails() {
    this.action.emit("next");
  }
  ProfilePicFullmodel() {
    $("#proFilePicFull").modal("show");
    $("#proFilePicFull").css("z-index", "1050");
  }
  OnCloseProfile() {
    $("#proFilePicFull").modal("hide");
  }
  onsdkSuccess(event: any) {
    if (event.success == true) {
      console.log("Successfully received event:", event);
      this.sdkEventData = event;}}

      ondigioSDKSuccess(event: any){
          if (event.data.actions[0].status == "success" || event.data.actions[0].status == "approved") {
                console.log("✅ EVENT RECEIVED in CUSTOEMR1:", event.data);
    this.digiosdkEventData = event;
          }
        }

  addCustomerLink(){
  this.openmodel="addCustomer"
  this.digioresponse ="addcustomerdigio"
}
  
  

}
